$wj([100],{

/***/ 1567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getExtensionFromFileName(fileName) {
    if (!fileName) {
        return null;
    }
    var start = fileName.lastIndexOf('.');
    if (start > 0) {
        return fileName.substr(start).toLowerCase();
    }
    return null;
}
exports.default = getExtensionFromFileName;
function getExtensionWithoutDotFromFileName(fileName) {
    var extension = getExtensionFromFileName(fileName);
    return extension ? extension.replace('.', '') : null;
}
exports.getExtensionWithoutDotFromFileName = getExtensionWithoutDotFromFileName;
//# sourceMappingURL=getExtensionFromFileName.js.map

/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = __webpack_require__(22);
var owa_strings_1 = __webpack_require__(20);
function numberToByteQuantifiedStringConverter(bytes) {
    var formatString;
    if (bytes >= 0x40000000) {
        // GB
        bytes /= 0x40000000;
        formatString = owa_mail_strings_1.default.sizeWithGigabyteAbbreviationText;
    }
    else if (bytes >= 0x100000) {
        // MB
        bytes /= 0x100000;
        formatString = owa_mail_strings_1.default.sizeWithMegabyteAbbreviationText;
    }
    else if (bytes >= 0x400) {
        // KB
        bytes /= 0x400;
        formatString = owa_mail_strings_1.default.sizeWithKilobyteAbbreviationText;
    }
    else {
        formatString = owa_mail_strings_1.default.sizeWithByteAbbreviationText;
    }
    return owa_strings_1.format(formatString, Math.round(bytes));
}
exports.default = numberToByteQuantifiedStringConverter;
//# sourceMappingURL=numberToByteQuantifiedStringConverter.js.map

/***/ }),

/***/ 1759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getExtensionFromFileName_1 = __webpack_require__(1567);
var imageFileExtensions = [
    '.bmp',
    '.gif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.jfif',
    '.dib',
    '.png',
    '.psd',
    '.tiff',
    '.tif',
];
function isImageFile(fileName) {
    var extension = getExtensionFromFileName_1.default(fileName);
    if (extension) {
        return imageFileExtensions.indexOf(extension.toLowerCase()) >= 0;
    }
    return false;
}
exports.default = isImageFile;
//# sourceMappingURL=isImageFile.js.map

/***/ }),

/***/ 2971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createLocalComputerFiles_1 = __webpack_require__(4043);
exports.createLocalComputerFiles = createLocalComputerFiles_1.default;
var createMailItemFiles_1 = __webpack_require__(4044);
exports.createMailItemFiles = createMailItemFiles_1.default;
var createUriFiles_1 = __webpack_require__(4045);
exports.createUriFiles = createUriFiles_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getExtensionFromFileName_1 = __webpack_require__(1567);
exports.getExtensionFromFileName = getExtensionFromFileName_1.default;
exports.getExtensionWithoutDotFromFileName = getExtensionFromFileName_1.getExtensionWithoutDotFromFileName;
var numberToByteQuantifiedStringConverter_1 = __webpack_require__(1578);
exports.numberToByteQuantifiedStringConverter = numberToByteQuantifiedStringConverter_1.default;
var isImageFile_1 = __webpack_require__(1759);
exports.isImageFile = isImageFile_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentFile_1 = __webpack_require__(2687);
function createLocalComputerFiles(fileList) {
    if (!fileList) {
        return null;
    }
    var localFiles = [];
    for (var i = 0; i < fileList.length; i++) {
        var file = fileList[i];
        var localFile = {
            fileType: AttachmentFile_1.AttachmentFileType.Local,
            name: file.name,
            size: file.size,
            type: file.type,
            fileObject: file,
        };
        localFiles.push(localFile);
    }
    return localFiles;
}
exports.default = createLocalComputerFiles;
//# sourceMappingURL=createLocalComputerFiles.js.map

/***/ }),

/***/ 4044:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentFile_1 = __webpack_require__(2687);
var owa_trace_1 = __webpack_require__(14);
function createMailItemFiles(subjects, latestItemIds) {
    if (subjects.length != latestItemIds.length) {
        owa_trace_1.trace.error('The sizes of subjects and latestItemIds are different');
        return null;
    }
    var mailItemList = [];
    for (var i = 0; i < subjects.length; i++) {
        var conversation = {
            fileType: AttachmentFile_1.AttachmentFileType.MailItem,
            name: subjects[i],
            size: 0,
            itemId: latestItemIds[i],
        };
        mailItemList.push(conversation);
    }
    return mailItemList;
}
exports.default = createMailItemFiles;
//# sourceMappingURL=createMailItemFiles.js.map

/***/ }),

/***/ 4045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentFile_1 = __webpack_require__(2687);
var owa_file_common_1 = __webpack_require__(323);
function createUriFiles(entries) {
    var uriList = entries.map(function (entry) {
        return {
            fileType: AttachmentFile_1.AttachmentFileType.Uri,
            name: entry.name,
            type: owa_file_common_1.getExtensionFromFileName(entry.url),
            size: 0,
            uri: entry.url,
        };
    });
    return uriList;
}
exports.default = createUriFiles;
//# sourceMappingURL=createUriFiles.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.AttachmentsCommon.js